import FqApi from '@/services/fq-api'
// import ProtoBufApi from '@/services/protobuf-api'
import ProtoBuf from 'protobufjs'

export default {
  async getPollingLogs(filter) {
    // console.log('get application logs')
    const serialised = this.serialiseMessageFilter(filter)
    console.log(filter)
    const url = `pollinglog/list/${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCompanyDropdownProto(name) {
    const url = `/companies/listcombo?name=${name}`
    const result = await FqApi.get(url)
    return result.data
  },
  serialiseMessageFilter(filter) {
    const proto = require('../../assets/proto/pollinglog/PollingLogFilter.proto')
    const filterMessage = proto.PollingLogFilter.PollingLogFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return b64encoded
  }
}
